import { Select } from '@workramp/ui';
import styled from 'styled-components';

export const StyledSelect = styled(Select)`
  margin-top: ${({ theme }) => theme.spacing(2)}px;
`;
